// extracted by mini-css-extract-plugin
export default {"wrapper":"organisation-area-groups-overlay_wrapper__2jL5I"};